<template>
    <main>
        <div class="firstDiv">
            <h1>
                <span class="campaigns">
                    <img src="../../../public/static/icons/icons8-defense-48.png" />My Campaigns
                </span>
            </h1>
            <span class="searchCampaign">
                <input v-model="searchQuery" placeholder="Search campaigns" />
                <router-link to="/create" tag="button">Create New Campaign</router-link>
            </span>
        </div>
        <section v-if="!error">
            <ul class="campaignsUl">
                <li v-for="campaign in filteredCampaigns" :key="campaign.id" class="campaignBorder">
                    <div class="mainDiv">
                        <!-- campaign image -->
                        <img class="campImg" :src="campaign.imageUrl" />
                        <h3 class="campaignTitle">&nbsp;{{ campaign.name }}</h3>
                        <em>
                            <span> <img src="../../../public/static/icons/star.png" /> </span>
                            &nbsp;{{ campaign.owner }}&nbsp;</em
                        >
                        <p>
                            Active players
                            <!-- drawing -->
                            <svg viewBox="0 0 100 100" height="28" width="28" style="user-select: none;">
                                <title>{{ campaign.players.length }} players</title>
                                <circle cx="50" cy="36" r="36" fill="black" />
                                <path d="M 0 100 L 18 74 L 26 68 H 74 L 82 74 L 100 100 Z" fill="black" />
                                <text fill="white" x="50" y="85" font-size="70" text-anchor="middle">
                                    <!-- end drawing -->
                                    {{ campaign.players.length }}
                                </text>
                            </svg>
                            <span>
                                <router-link
                                    :to="{ name: 'live-play', params: { sessionId: campaign.id, sceneId: 'debug' } }"
                                    tag="button"
                                    >Play
                                </router-link>
                                <button @click="display(campaign)" v-on:click="border">info</button>
                            </span>
                        </p>
                    </div>
                    <section v-if="campaign.name == clickedCampaign.name">
                        <div class="descriptionDiv" v-show="hover">
                            <h3 class="campaignTitle">
                                &nbsp;{{ campaign.name
                                }}<span><img class="smallCampImg" :src="campaign.imageUrl"/></span>
                            </h3>
                            <em
                                ><span><img src="../../../public/static/icons/star.png"/></span>&nbsp;{{
                                    campaign.owner
                                }}&nbsp;</em
                            >
                            <p>Campaign Description:</p>
                            <div class="selectedCampaignDesc">
                                <textarea cols="50" rows="8" maxlength="310" v-model="campaign.description" />
                            </div>

                            <div class="selectedCampaignTime">
                                <span>Start Date:</span> {{ startDate }}<br />
                                <span>Last Played: </span> {{ campaign.lastModified }}
                            </div>
                            <div class="inviteLinkDiv">
                                <span v-if="oidcUser && oidcUser.name == campaign.owner">
                                    <a :href="`/invite/${campaign.id}`">Invite Link</a>
                                    <router-link :to="`/edit/${campaign.id}`" tag="button">Edit</router-link>
                                    <button @click="deleteCampaign(campaign)">Delete</button>
                                </span>
                                <router-link
                                    :to="{ name: 'live-play', params: { sessionId: campaign.id, sceneId: 'debug' } }"
                                    tag="button"
                                    >Play</router-link
                                >
                            </div>
                        </div>
                    </section>
                </li>
            </ul>
        </section>
        <section v-if="error">
            {{ error }}
        </section>
    </main>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            campaigns: [],
            searchQuery: '',
            focusedCampaign: null,
            error: '',
            banner: null,
            imageUrl: '',
            startDate: '',
            lastPlayed: '',
            selectedCampaign: {
                name: '',
                styleObject: {
                    border: '2px solid white',
                },
            },
            hover: false,
            ant: '',
            clickedCampaign: '',
        };
    },
    computed: {
        ...mapGetters(['oidcUser']),
        filteredCampaigns: function() {
            return this.campaigns.filter(c => c.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
    },
    beforeRouteEnter(to, from, next) {
        axios
            .get(`/api/campaigns`)
            .then(response => {
                next(vm => vm.setData(response.data));
            })
            .catch(error => {
                next(vm => vm.setError(error));
            });
    },
    mounted() {
        this.hover = false;
    },
    methods: {
        setData(data) {
            this.campaigns = data;
        },
        // eslint-disable-next-line no-unused-vars
        setError(error) {
            this.error = 'Error loading campaign list.';
        },
        focusCampaign(campaign) {
            this.focusedCampaign = campaign;
        },
        display(campaign) {
            this.campaign = campaign;
            this.startDate = this.campaign.created;
            this.hover = !this.hover;
            this.isActive = !this.isActive;
            this.clickedCampaign = this.campaign;
        },
        border: function(event) {
            if (this.ant != '') {
                this.ant.style.border = '1px solid white';
            }
            event.target.parentNode.parentNode.parentNode.parentNode.style.border = '4px double rgb(137, 154, 253)';
            this.ant = event.target.parentNode.parentNode.parentNode.parentNode;
        },
        unfocusCampaign() {
            this.focusedCampaign = null;
        },
        refresh() {
            axios
                .get(`/api/campaigns`)
                .then(response => {
                    this.setData(response.data);
                })
                .catch(error => {
                    this.setError(error);
                });
        },
        deleteCampaign(campaign) {
            axios.delete(`/api/campaigns/${campaign.id}`).then(() => {
                this.refresh();
                this.hover = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

main {
    display: grid;
    grid-template-columns: 65% 35%;
    grid-template-rows: 20% 70%;
    background-color: rgb(42, 50, 153);
    min-height: 620px;
}

.descriptionDiv {
    clear: both;
    background-color: rgb(59, 59, 231);
    opacity: 0.8;
    grid-area: 2 / 2;
    border-radius: 10px;
    padding: 20px;
    padding-bottom: 110px;
    color: white;
    width: 550px;
}

.firstDiv .campaigns img {
    position: relative;
    top: 14px;
}

.mainDiv span img {
    position: relative;
    top: 1px;
    width: 12px;
    height: 12px;
    margin-left: 5px;
}

a:link,
a:visited {
    color: white;
    text-decoration: none;
}

a:hover {
    color: yellow;
}

.firstDiv {
    grid-area: 1 / 1 / 1 / span 2;
    padding: 0;
    margin: 0;
    color: white;
    background-color: rgb(66, 66, 221);
    height: 90px;
    border-radius: 10px;
    padding-right: 20px;
    padding-left: 10px;
    margin-right: 10px;
    margin-left: 10px;
}

.firstDiv h1 {
    float: left;
}

.firstDiv span {
    float: right;
    position: relative;
    top: -15px;
}

.searchCampaign button,
input {
    position: relative;
    top: 45px;
}

section {
    max-height: 560px;
}

.campaignsUl {
    margin: 10px;
    margin-left: 100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
}

.campaignsUl li {
    color: white;
    font-weight: bold;
    background-color: rgb(4, 24, 90);
    flex-basis: 300px;
    height: 240px;
    border: 1px solid gray;
    border-radius: 10px;
    margin: 4px;
    margin-bottom: 20px;
    list-style-type: none;
}

main {
    padding-top: 10px;
}

input {
    margin-right: 1rem;
}

.firstDiv .campaigns {
    border-right: 2px solid gray;
    height: 75px;
    padding-right: 20px;
}

.searchCampaign span {
    clear: both;
    height: 100px;
    border: 1px solid white;
}

.mainDiv p {
    color: rgb(137, 154, 253);
    font-size: 0.8rem;
    margin-left: 10px;
    margin-right: 10px;
}

.selectedCampaignDesc {
    border-radius: 12px;
    font-size: 0.8rem;
    padding: 12px;
    margin-top: 5px;
    margin-bottom: 10px;
}

.selectedCampaignTime {
    border-radius: 5px;
    text-align: justify;
    font-weight: normal;
    font-size: 0.8rem;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 250px;
}

.selectedCampaignTime span {
    font-weight: bold;
    font-size: 0.8rem;
}

.descriptionDiv {
    position: -webkit-sticky;
    position: fixed;
    right: 1px;
    top: 250px;
    bottom: 10px;
    background-color: rgb(4, 24, 90);
    border: 4px double rgb(137, 154, 253);
    margin-right: 10px;
    margin-top: 10px;
}

.descriptionDiv img {
    width: 12px;
    height: 12px;
}

.descriptionDiv p {
    font-size: 0.9rem;
}

.inviteLinkDiv {
    font-size: 0.9rem;
    width: 260px;
    padding: 10px;
    border-radius: 5px;
}

.inviteLinkDiv > button:hover,
span button:hover {
    background-color: darkblue;
}

h3 span > .smallCampImg {
    position: relative;
    top: 10px;
    width: 50px;
    height: 30px;
    margin-left: 5px;
    border-radius: 5px;
    border: 1px solid white;
}

.mainDiv button {
    position: relative;
    left: 150px;
}

.descriptionDiv .selectedCampaignDesc textarea {
    background-color: rgb(66, 66, 221);
    resize: none;
    color: white;
    text-align: justify;
    font-weight: normal;
    width: 100%;
}

.campImg {
    padding: 0px;
    margin: 2px;
    width: 385px;
    height: 110px;
    border-radius: 10px;
    border: 0.5px solid white;
    object-fit: cover;
}

.campaignTitle {
    margin: 0;
    padding: 0;
    padding-bottom: 10px;
    margin-left: 5px;
}
</style>
